// Photos taken with phones weigh several MB; the report PDF embeds them, so they are resized and converted to JPEG
// (the only formats the PDF generator accepts are JPEG and PNG) before uploading.
const MAX_SIDE = 1800
const QUALITY = 0.85

const loadImage = (file) => new Promise((resolve, reject) => {
  const url = URL.createObjectURL(file)
  const img = new Image()
  img.onload = () => { URL.revokeObjectURL(url); resolve(img) }
  img.onerror = () => { URL.revokeObjectURL(url); reject(new Error('Formato de imagen no soportado. Usa JPG o PNG.')) }
  img.src = url
})

export const compressImage = async (file) => {
  const img = await loadImage(file)
  const scale = Math.min(1, MAX_SIDE / Math.max(img.naturalWidth, img.naturalHeight))
  const canvas = document.createElement('canvas')
  canvas.width = Math.round(img.naturalWidth * scale)
  canvas.height = Math.round(img.naturalHeight * scale)
  const ctx = canvas.getContext('2d')
  // White background so transparent PNGs do not turn black in JPEG.
  ctx.fillStyle = '#FFFFFF'
  ctx.fillRect(0, 0, canvas.width, canvas.height)
  ctx.drawImage(img, 0, 0, canvas.width, canvas.height)
  return new Promise((resolve, reject) => {
    canvas.toBlob(blob => (blob ? resolve(blob) : reject(new Error('No se pudo procesar la imagen.'))), 'image/jpeg', QUALITY)
  })
}

export const isImage = (file) => /^image\//.test(file?.type || '')
export const isPdf = (file) => file?.type === 'application/pdf' || /\.pdf$/i.test(file?.name || '')
